import React, { Component } from 'react'
import classnames from 'classnames'
import {Translations} from '../../../../../utils';
//
// import _ from './utils'

const defaultButton = props => (
<button type='button' {...props} className='-btn'>
  {props.children}
</button>
)

export default class ReactTablePagination extends Component {
  constructor (props) {
    super()

    this.getSafePage = this.getSafePage.bind(this)
    this.changePage = this.changePage.bind(this)
    this.applyPage = this.applyPage.bind(this)

    this.state = {
      page: props.page,
      isActive: props.defaultPageSize,
      hidedRow : props.data.length - props.defaultPageSize
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({ page: nextProps.page })
  }

  getSafePage (page) {
    if (isNaN(page)) {
      page = this.props.page
    }
    return Math.min(Math.max(page, 0), this.props.pages - 1)
  }

  changePage (page) {
    page = this.getSafePage(page)
    this.setState({ page })
    if (this.props.page !== page) {
      this.props.onPageChange(page)
    }
  }

  applyPage (e) {
    e && e.preventDefault()
    const page = this.state.page
    this.changePage(page === '' ? this.props.page : page)
  }
  onPageSizeChange = (option) => {
    this.props.onPageSizeChange(option);
    let _state = this.state;
    _state['isActive'] = option;
    this.setState(_state);
  }
  render () {
    const {
      // Computed
      pages,
      // Props
      page,
      showPageSizeOptions,
      pageSizeOptions,
      canPrevious,
      canNext,
      className,
      PreviousComponent = defaultButton,
      NextComponent = defaultButton,
      data
    } = this.props

    // const calculatePageSize =() =>{
      //
      //
      //    let getLength = Math.round(this.props.sortedData.length/pageSize);
      //
      //    return getLength;
      //
      // }
      const calculateTotalRecords =() =>{
        return this.props.sortedData.length;
      }
      return (
      <div
      className={classnames(className, '-pagination')}
      style={this.props.paginationStyle}
      >

      { this.props.data.length > this.props.defaultPageSize ? showPageSizeOptions &&
        <div className='select-wrap -pageSizeOptions'>
          <span className="gdoc-paginationshow">{Translations(this.props.pageJsonContent.table_caseHistoryTable.groupSelectPrefixText,this.props.lang.currentLang.lang, this.props.lang.translatedData)}</span>
          <ul className="gdoc-grid-pagination">
            {pageSizeOptions.map((option, i) => {
              return (
              <li className={this.state.isActive === option  ? 'active':''} key={i}  onClick={e => this.onPageSizeChange(option)}>
                <span>{option} </span>
              </li>
              )
            })}
            <li className={this.state.isActive === data.length  ? 'active':''}   onClick={e => this.onPageSizeChange(data.length)}>  
            <span>{Translations(this.props.pageJsonContent.table_caseHistoryTable.groupSelectAllText,this.props.lang.currentLang.lang, this.props.lang.translatedData)}</span>
            </li>

          </ul>
          <span>{`${Translations(this.props.pageJsonContent.table_caseHistoryTable.groupSelectSuffixText,this.props.lang.currentLang.lang, this.props.lang.translatedData)} ${calculateTotalRecords()} ${Translations(this.props.pageJsonContent.table_caseHistoryTable.groupSelectCaseText,this.props.lang.currentLang.lang, this.props.lang.translatedData)}`}</span>
        </div> : ""}


        {this.props.data.length > 0 ? <div className="gdoc-next-pre">
          <div className="paging-details">
            <span>{`${Translations(this.props.pageJsonContent.table_caseHistoryTable.pageLabel,this.props.lang.currentLang.lang, this.props.lang.translatedData)} ${page+1} ${Translations(this.props.pageJsonContent.table_caseHistoryTable.groupSelectSuffixText,this.props.lang.currentLang.lang, this.props.lang.translatedData)} ${pages}`}</span>
          </div>
          <div className='-previous'>
            <PreviousComponent
            onClick={e => {
              if (!canPrevious) return
              this.changePage(page - 1)
            }}
            disabled={!canPrevious}
            >
            <i className="icon icon-chevron-left" aria-label="previous page"></i>
          </PreviousComponent>
        </div>


        <div className='-next'>
          <NextComponent
          onClick={e => {
            if (!canNext) return
            this.changePage(page + 1)
          }}
          disabled={!canNext}
          >
          <i className="icon icon-chevron-right" aria-label="previous page"></i>
        </NextComponent>
      </div>
    </div>
    :''}  </div>
    )
  }
}

/*{showPageSizeOptions &&
  <span className='select-wrap -pageSizeOptions'>
    <select
    onChange={e => onPageSizeChange(Number(e.target.value))}
    value={pageSize}
    >
    {pageSizeOptions.map((option, i) => {
      return (
      <option key={i} value={option}>
        {option} {this.props.rowsText}
      </option>
      )
    })}
  </select>
</span>} */


/*
<div className='-center'>
  <span className='-pageInfo'>
    {this.props.pageText}{' '}
    {showPageJump
      ? <div className='-pageJump'>
        <input
        type={this.state.page === '' ? 'text' : 'number'}
        onChange={e => {
          const val = e.target.value
          const page = val - 1
          if (val === '') {
            return this.setState({ page: val })
          }
          this.setState({ page: this.getSafePage(page) })
        }}
        value={this.state.page === '' ? '' : this.state.page + 1}
        onBlur={this.applyPage}
        onKeyPress={e => {
          if (e.which === 13 || e.keyCode === 13) {
            this.applyPage()
          }
        }}
        />
      </div>
      : <span className='-currentPage'>
        {page + 1}
      </span>}{' '}
      {this.props.ofText}{' '}
      <span className='-totalPages'>{pages || 1}</span>
    </span>

    */



// WEBPACK FOOTER //
// ./src/components/CaseBody/CaseHistory/Grid/Table/pagination.js